import { useMatchRoute } from '@tanstack/react-router'

import { useBlockedPages } from './useBlockedPages'

export function useIsCurrentPageBlocked(): boolean {
  const blockedPages = useBlockedPages()
  const matchRoute = useMatchRoute()

  for (const blockedPage of blockedPages) {
    if (matchRoute({ to: blockedPage, fuzzy: true })) {
      return true
    }
  }

  return false
}
